import React                   from 'react'
import withBaseComponent from '../withBaseComponent';
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import {mapDispatchToProps} from "../mapDispatchToProps"
import Loading from '../common/Loading'
import { initGA, logPageView } from "./layouts/GoogleAnalytics.js"

class Support extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props)

    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.changeIsReply = this.changeIsReply.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      showReplyEmailField: false,
      isProcessing: false,
      succeed: false
    };
  }

  componentWillMount() {
    const { supportTypes } = this.props;
    if(!supportTypes || !supportTypes.length) {
      Promise.all([this.props.userActions.supportEmailTypes()]).then(res => {
        return res;
      });
    }
  }

  onSubmit(model) {
    if (!this.state.canSubmit) {
      return false;
    }

    this.setState({isProcessing: true})
    this.props.userActions.supportEmailCreate({support_email: model}).then(res => {
      this.onSuccess();
      return res
    });
  }

  onSuccess() {
    this.setState({succeed: true, isProcessing: false})
  }

  changeIsReply(event) {
    const target = event.target;
    this.setState({ showReplyEmailField: target.checked });
  }

  pageView () {
    if (!window.GA_INITIALIZED) {
      initGA()
      window.GA_INITIALIZED = true
    }
    logPageView()
  }

  render() {
    // const { showReplyEmailField, succeed, isProcessing } = this.state;
    const { supportTypes } = this.props;

    if (!supportTypes || !supportTypes.length) {
      return <Loading className="fa-7x loading" />;
    }

    return (
      <div className="support-container small-container" id="support-container">
        <div className="row no-gutters">
          <div className="col-sm-9 title padl-0">{i18n.t("support.qa")}</div>
          <div className="col-sm-12 content-body support-qa">
            <a className="qa-link" target="_blank" href="https://transaction2.zendesk.com/hc/ja" rel="noopener noreferrer">
              {i18n.t('support.qa_link.title')}
            </a>
            <br/>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-sm-9 title padl-0">{i18n.t("support.contact")}</div>
          <div className="col-sm-12 content-body">
            <div className="row align-items-center" style={{padding: '16px'}}>
              <label className="" style={{margin: 'auto'}}>
                ご質問、ご相談は「statement.feedback@moneyforward.com」宛にお送りください。
              </label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    supportTypes: state.user.get('supportTypes') || [],
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Support)
